import React, { useState } from 'react'
import { Pagination } from 'antd'
import Card from '../Common/Card'
import user from "../Images/user.svg"
import ButtonGroup from '../Common/ButtonGroup'
import SelectList from '../Common/SelectList'
import DashboardTable from '../Common/DashboardTable';
import SearchBtn from '../Common/SearchBtn'
import ConvertButtons from '../Common/ConvertButtons'

const Home = () => {
    const dashBoard = [];
    const [data, setData] = useState(dashBoard);
    const [searchTerm, setSearchTerm] = useState('');
    const [page, setPage] = useState(1);
    const [postPerPage, setPostPerPage] = useState(10);
    const dataRef = React.createRef();

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <a>Previous</a>;
        } else if (type === 'next') {
            return <a>Next</a>;
        }
        return originalElement;
    };

    const indexOfLastPage = page * postPerPage;
    const indexOfFirstPage = indexOfLastPage - postPerPage;
    const currentPost = data.slice(indexOfFirstPage, indexOfLastPage);
    return (
        <>
            <div className='items-center w-full h-screen overflow-auto p-4 bg-slate-100 '>

                <ButtonGroup />

                {/* main content */}

                <div className='bg-white w-full pb-3 '>
                    <div className='pt-4 px-2'>
                        <marquee scrollamount="5" className="text-md py-2 px-2 bg-white">Daily Income: Rs.0 | Weekly Income: Rs.0 | Montly Income: Rs.400 | Yearly Income: Rs.0</marquee>

                        <div className='py-2 px-2'>
                            <div>
                                <h1 className='py-5 text-center sm:text-left sm:px-3 md:px-1 lg:px-0 '>Summary</h1>
                            </div>

                            {/* card start */}
                            <div className='grid gap-5 place-content-center  xsm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 '>
                                <Card
                                    color1="bg-blueE-400"
                                    color2="bg-blueE-500"
                                    title="0"
                                    para="Today Expiry"
                                    avt={user}
                                    foot="More Info"
                                />
                                <Card
                                    color1="bg-greenN-300"
                                    color2="bg-greenN-500"
                                    color3="bg-greenN-300"
                                    title="0"
                                    para="Today Enrollment"
                                    avt={user}
                                    foot="More Info"
                                />
                                <Card
                                    color1="bg-greenN-600"
                                    color2="bg-greenN-700"
                                    title="0"
                                    para="Today Enquiry"
                                    avt={user}
                                    foot="More Info"
                                />

                                <Card
                                    color1="bg-orangeE-100"
                                    color2="bg-orangeE-200"
                                    title="0"
                                    para="Today Employees"
                                    avt={user}
                                    foot="More Info"
                                />

                                <Card
                                    color1="bg-redD-100"
                                    color2="bg-redD-200"
                                    title="0"
                                    para="Today Birthdays"
                                    avt={user}
                                    foot="More Info"
                                />

                                <Card
                                    color1="bg-greenN-800"
                                    color2="bg-greenN-900"
                                    title="Rs. 0"
                                    para="Today Receipts"
                                    avt={user}
                                    foot="More Info"
                                />

                                <Card
                                    color1="bg-orangeE-300"
                                    color2="bg-orangeE-400"
                                    title="0"
                                    para="Today Followup"
                                    avt={user}
                                    foot="Today Followup"
                                />

                                <Card
                                    color1="bg-orangeE-500"
                                    color2="bg-orangeE-600"
                                    title="Rs. 400"
                                    para="Total Dues"
                                    avt={user}
                                    foot="Total Dues"
                                />
                            </div>
                            {/* card End */}
                        </div>
                    </div>
                </div>




                <div className='flex flex-col bg-white py-6 px-2'>
                    <div><h2 className="font-semibold text-lg">Enrollment going to expire within 15 days</h2></div>

                    <div className='flex sm:justify-between justify-center items-center flex-wrap py-4'>
                        <div className='flex mt-3 mb-4'>
                            <SelectList />
                        </div>

                        <div className='flex mt-3 '>
                            <ConvertButtons
                                data={data}
                                ref={dataRef}
                            />
                        </div>
                    </div>

                    <div className="flex justify-center items-center flex-wrap mb-3 gap-2 ">
                        <SearchBtn
                            setSearchTerm={setSearchTerm}
                        />
                    </div>

                    {/* buttonGroup start */}

                    <DashboardTable
                        searchTerm={searchTerm}
                        data={currentPost}
                        ref={dataRef}
                    />

                    {/* buttonGroup end */}
                    <div className='px-8 py-3 flex flex-col gap-2 sm:flex-row sm:justify-between items-center'>
                        <p className='text-sm text-gray-800'>
                            showing {page} to {currentPost.length} of {data.length} entries
                        </p>
                        <Pagination
                            total={data.length}
                            onChange={value => setPage(value)}
                            itemRender={itemRender}
                            pageSize={postPerPage}
                            current={page}
                        />
                    </div>
                </div>

            </div>
        </>
    )
}

export default Home
